import { jsx as _jsx } from "react/jsx-runtime";
var Trash = function Trash(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 0.8125 * size,
    height: size,
    viewBox: "0 0 26 32",
    children: /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M13.15 27.65c0.3 0 0.55-0.25 0.55-0.55v-17.9c0-0.3-0.25-0.55-0.55-0.55s-0.55 0.25-0.55 0.55v17.9c0 0.3 0.25 0.55 0.55 0.55zM7.65 27.65c0.3 0 0.55-0.25 0.55-0.55 0 0 0 0 0 0v-17.9c0-0.3-0.25-0.55-0.55-0.55s-0.55 0.25-0.55 0.55v17.9c0 0.3 0.25 0.55 0.55 0.55zM18.6 27.65c0.3 0 0.55-0.25 0.55-0.55v-17.9c0-0.3-0.25-0.55-0.55-0.5-0.3 0-0.5 0.25-0.5 0.5v17.9c-0.050 0.3 0.2 0.55 0.5 0.55zM25.75 3.25h-7.7c-0.050-0.95-0.4-1.85-1-2.55-0.45-0.45-1.1-0.7-1.7-0.7h-5.5c-0.65 0-1.25 0.25-1.7 0.7-0.6 0.7-0.95 1.6-1 2.55h-6.6c-0.3 0-0.55 0.25-0.55 0.55s0.25 0.55 0.55 0.55v0h1.1l1.050 24.95c-0.050 1.45 1.1 2.65 2.6 2.7 0.050 0 0.050 0 0.1 0h15.5c1.45 0.050 2.65-1.15 2.7-2.6 0-0.050 0-0.050 0-0.1l1.050-24.95h1.1c0.3 0 0.55-0.25 0.55-0.55s-0.25-0.55-0.55-0.55v0zM8.9 1.45c0.25-0.25 0.6-0.4 0.95-0.35h5.45c0.35 0 0.7 0.1 0.95 0.35 0.4 0.5 0.65 1.15 0.7 1.8h-8.7c0.050-0.65 0.25-1.3 0.65-1.8v0zM22.45 29.25c0.050 0.85-0.65 1.6-1.5 1.65 0 0-0.050 0-0.050 0h-15.5c-0.9 0-1.6-0.7-1.6-1.6 0 0 0-0.050 0-0.050l-1.050-24.9h20.75l-1.050 24.9z"
    })
  });
};
export default Trash;